<template>
  <div class="button outlined" @click="showModal()" style="margin-top: 0.8rem;">（ログアウト）</div>
  <div class="form formLogout" v-if="show" @click.self="closeModal">
    <div class="box">
      <div class="contents">
        <div class="logout">
          <h3>ログアウトしますか？</h3>
          <div class="next">
            <div class="button">ログアウトする</div>
            <div class="textLink" @click="closeModal">キャンセル</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    },
  },
};
</script>
